import type { GameConfig, GameMode } from '@/types';

export const GAME_CONFIGS: Record<GameMode, GameConfig> = {
  casual: {
    mode: 'casual',
    smallBlind: 10,
    bigBlind: 20,
    entryFee: 0,
    maxPlayers: 6,
    minPlayers: 2,
  },
  tournament_low: {
    mode: 'tournament_low',
    smallBlind: 25,
    bigBlind: 50,
    entryFee: 500,
    maxPlayers: 6,
    minPlayers: 2,
    startingChips: 1500,
    blindIncreaseInterval: 5,
  },
  tournament_mid: {
    mode: 'tournament_mid',
    smallBlind: 50,
    bigBlind: 100,
    entryFee: 2000,
    maxPlayers: 8,
    minPlayers: 2,
    startingChips: 3000,
    blindIncreaseInterval: 5,
  },
  tournament_high: {
    mode: 'tournament_high',
    smallBlind: 100,
    bigBlind: 200,
    entryFee: 5000,
    maxPlayers: 10,
    minPlayers: 2,
    startingChips: 5000,
    blindIncreaseInterval: 5,
  },
  turbo: {
    mode: 'turbo',
    smallBlind: 50,
    bigBlind: 100,
    entryFee: 1000,
    maxPlayers: 6,
    minPlayers: 2,
    startingChips: 2000,
    blindIncreaseInterval: 2,
  },
};

export const INITIAL_CHIPS = 10000;
export const DAILY_SIGNIN_REWARD = 500;
export const RELIEF_AMOUNT = 2000;
export const MAX_DAILY_RELIEF = 3;
export const BANKRUPT_THRESHOLD = 100;

export const SCORE_REWARDS = {
  tournament_low: { first: 100, second: 60, third: 30 },
  tournament_mid: { first: 200, second: 120, third: 60 },
  tournament_high: { first: 500, second: 300, third: 150 },
  streak_3: 50,
  streak_5: 150,
  streak_10: 500,
  bluff_success: 10,
  royal_flush: 1000,
};

export const AI_NAMES = [
  'Alex', 'Bob', 'Charlie', 'David', 'Emma', 'Frank', 'Grace', 'Henry',
  'Ivy', 'Jack', 'Kate', 'Leo', 'Mia', 'Noah', 'Olivia', 'Paul'
];

export const AVATARS = [
  'avatar1', 'avatar2', 'avatar3', 'avatar4', 'avatar5',
  'avatar6', 'avatar7', 'avatar8', 'avatar9', 'avatar10',
];

export const POSITION_ORDER: Record<number, string[]> = {
  2: ['SB', 'BB'],
  3: ['BTN', 'SB', 'BB'],
  4: ['BTN', 'SB', 'BB', 'UTG'],
  5: ['BTN', 'SB', 'BB', 'UTG', 'CO'],
  6: ['BTN', 'SB', 'BB', 'UTG', 'MP', 'CO'],
  7: ['BTN', 'SB', 'BB', 'UTG', 'UTG+1', 'MP', 'CO'],
  8: ['BTN', 'SB', 'BB', 'UTG', 'UTG+1', 'MP', 'MP+1', 'CO'],
  9: ['BTN', 'SB', 'BB', 'UTG', 'UTG+1', 'MP', 'MP+1', 'CO', 'EP'],
  10: ['BTN', 'SB', 'BB', 'UTG', 'UTG+1', 'MP', 'MP+1', 'CO', 'EP', 'LP'],
};

export const HAND_RANK_NAMES: Record<number, string> = {
  10: '皇家同花顺',
  9: '同花顺',
  8: '四条',
  7: '葫芦',
  6: '同花',
  5: '顺子',
  4: '三条',
  3: '两对',
  2: '一对',
  1: '高牌',
};

export const SUIT_SYMBOLS: Record<string, string> = {
  hearts: '♥',
  diamonds: '♦',
  clubs: '♣',
  spades: '♠',
};

export const SUIT_COLORS: Record<string, string> = {
  hearts: 'text-red-500',
  diamonds: 'text-red-500',
  clubs: 'text-slate-800',
  spades: 'text-slate-800',
};
